module.exports = __webpack_public_path__ + "img/icon-upload.b2803d6b.svg";